<template>
  <v-card
    class="pt-12 pb-0"
    elevation="0"
    tile
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '300'"
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <div v-for="(item, i) in logos" :key="i">
      <div v-if="isLogoVisible(item.codigo)">
        <title-component :id="id" :settings="{...getCustomLogoInfo(item.codigo).settings, idLayout: settings.idLayout}" />
        <v-container style="max-width: 1340px">
          <v-row class="mx-12 my-12" justify="center">
            <v-col
              v-for="(logo, index) in item.logos"
              :key="index"
              :cols="
                $vuetify.breakpoint.mdAndUp ? 
                  getCustomLogoInfo(item.codigo).column ? getCustomLogoInfo(item.codigo).column : '2'
                  : 
                  item.logos && item.logos.length === 1 ? '10' : '6'
              "
              align="center"
              :class="$vuetify.breakpoint.mdAndUp ? 'pa-6' : ''"
            >
              <v-img
                :height="$vuetify.breakpoint.mdAndUp ? sizeMdUp[getCustomLogoInfo(item.codigo).tamanho] : '100px'"
                eager
                contain
                :src="logo.url_imagem"
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import TitleComponent from "../title/TitleComponent.vue";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],  
  components: { TitleComponent },
  props: {
    id: {type: String},
    settings: { type: Object },
  },

  data() {
    return {
      sizeMdUp: {
        P: "35",
        M: "55",
        G: "85",
      },
      sizeMdDown: {
        P: "55",
        M: "85",
        G: "120",
      },
    };
  },

  computed: {
    ...mapGetters(["logos"]),
  },

  methods: {
    isLogoVisible (codigo) {
      const isSelected = this.settings.items.find(logo => logo.codigo === codigo)
      return isSelected ? true : false
    },

    getCustomLogoInfo (codigo) {
      const logo = this.settings.items.find(logo => logo.codigo === codigo)
      return logo
    }
  }
}
</script>

<style scoped>
.div-style {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
